import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Grid, IconButton } from "@mui/material";
import Freez from '../../../Components/Loader/Loader'
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from "react-router-dom";

const DefaultTemplates = () => {
    const [freez, setFreez] = React.useState(false);
    const navigate = useNavigate();
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const location = useLocation();
    const selectedRows = location.state?.selectedRows || [];
    const uploadedFile = location.state?.uploadedFile || null;
      const selectedReport = location.state?.selectedReport || null;
    const defaultTemplates = [
        { id: 1, name: "Layout 1", layout: ["image", "header", [["paragraph"], ["paragraph"]], "footer"] },
        { id: 2, name: "Layout 2", layout: ["header", "image", "paragraph", "footer"] },
        { id: 3, name: "Layout 3", layout: ["header", "paragraph", "image", "footer"] },
        { id: 4, name: "Layout 4", layout: ["header", "paragraph", "image", "footer",] }
    ];

    const blockHeights = {
        image: 40,
        header: 20,
        "content-left": 50,
        "content-right": 50,
        paragraph: 30,
        footer: 20
    }
    const ContentLayout =
        <>
            <Box sx={{ padding: 1 }}>
                <IconButton onClick={() => navigate(-1)} sx={{ mb: 2 }}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Default Layout
                </Typography>
                <Grid container spacing={3}>
                    {defaultTemplates.map((template) => (
                        <Grid item xs={12} sm={6} md={3} key={template.id}>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        width: 180,
                                        height: 200,
                                        borderRadius: 2,
                                        border: "1px solid #BEBABA",
                                        textAlign: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: 2,
                                        cursor: "pointer"
                                    }}
                                    onClick={() => navigate("/email-editor", { state: { template,selectedRows, uploadedFile,selectedReport } })}
                                >
                                    <Grid container spacing={1}>
                                        {template.layout.map((item, index) =>
                                            Array.isArray(item) ? (
                                                <Grid container item xs={12} spacing={1} key={index}>
                                                    {item.map((col, colIndex) => (
                                                        <Grid item xs={6} key={colIndex}>
                                                            <Box
                                                                sx={{
                                                                    width: "100%",
                                                                    height: blockHeights[col],
                                                                    backgroundColor: "#D9D9D9",
                                                                    borderRadius: 1,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            ) : (
                                                <Grid item xs={12} key={index}>
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            height: blockHeights[item] || 20,
                                                            backgroundColor: "#D3D3D3",
                                                            borderRadius: 1,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        {item === "image" && (
                                                            <img
                                                                src={require("../../../assets/icons/galleryImg.png")}
                                                                alt="Gallery Icon"
                                                                width={30}
                                                            />
                                                        )}
                                                    </Box>
                                                </Grid>
                                            )
                                        )}
                                    </Grid>
                                </Card>
                                <Typography variant="body1" fontWeight="bold" sx={{ mt: 1, textAlign: "center" }}>
                                    {template.name}
                                </Typography>
                            </Box>
                        </Grid>

                    ))}
                </Grid>
            </Box>
        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                    onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div></>
    );
};

export default DefaultTemplates;